import { Component, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Observable, fromEvent, filter } from "rxjs";
import { AuthenticationService } from "./core/services/authentication.service";
import { EnvironmentService } from "./core/services/environment.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  _authService = inject(AuthenticationService);

  title = "SyncHPC";
  hideHeader: boolean = false;
  url: string;
  hidemenubar = false;
  public primaryColor = "white";
  isUserLoggedIn: boolean = false;
  currentTab: string;
  isUserVdiOnly: boolean = false;
  vdiModeOnly = this.env.envVariables.vdiModeOnly;
  isClientLogin = this.router.url.includes("desktopapp"); // check for desktopapp

  vdiModeOn = false;

  constructor(
    private snackbar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private env: EnvironmentService
  ) {}

  // Observables & Subscriptions to check online/offline connectivity status
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  //Get the online/offline connectivity status from browser window
  checkOnlineStatus() {
    this.onlineEvent = fromEvent(window, "online");
    this.offlineEvent = fromEvent(window, "offline");
    this.onlineEvent.subscribe(() => {
      this.snackbar.open("Internet Connection Restored.", "Ok", {
        duration: 5000,
      });
    });
    this.offlineEvent.subscribe(() => {
      this.snackbar.open(
        "No Internet Connection. Please check your Internet Connection."
      );
    });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.checkOnlineStatus();
    // check if route Client Sessions is active
    (window as any).MonacoEnvironment = {
      getWorkerUrl: function(workerId: string, label: string) {
        return `./assets/monaco-editor/min/vs/base/worker/workerMain.js`;
      }
    };
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentTab = event.url;
        // Check the route and perform actions based on the route
        if (decodeURIComponent(event.url).includes("desktopapp")) {
          localStorage.setItem('lastVisitedRoute', this.currentTab);
          this.vdiModeOn = true;
        } else if (
          this.vdiModeOnly &&
          (decodeURIComponent(event.url).includes("desktopapp") ||
            this.isUserVdiOnly)
        ) {
          this.hideHeader = true;
        } else {
          this.hideHeader = false;
        }
      });
    this.route.url.subscribe((url) => {
      this.url = url[0].path;
    });
    this._authService.currentUser.subscribe(async (user) => {
      if (user) this.isUserLoggedIn = true;
      else this.isUserLoggedIn = false;
      if (user) {
        this.isUserVdiOnly = user.isUserVdiOnly;
      }
    });


    // This will add a property that can be used for border color which is darker than the primary color
    const primary = getComputedStyle(document.documentElement)
    .getPropertyValue('--s-primary-color')
    .trim() || '#0072c6';

    const darkenColor = (hex: string, percent: number): string => {
      const num = parseInt(hex.replace('#', ''), 16);
      const amt = Math.round(2.55 * percent);
      const R = Math.max((num >> 16) - amt, 0);
      const G = Math.max(((num >> 8) & 0x00FF) - amt, 0);
      const B = Math.max((num & 0x0000FF) - amt, 0);
      return `rgb(${R}, ${G}, ${B})`;
    };

    const darker = darkenColor(primary, 10);
    const text = getComputedStyle(document.documentElement).getPropertyValue('--s-text-color').trim();
    const darkened = darkenColor(text, 50); // your helper
    document.documentElement.style.setProperty('--s-text-color-hover', darkened);


    document.documentElement.style.setProperty('--s-primary-darker-color', darker);
  }
}
